/**
 * 장비 슬롯·레어도. 수치는 `equipment.json`, 개별 아이템은 `items.json`.
 */

import seed from './equipment.json';
import { emitDataReloadSoon, replaceRecord, requireRecord } from './catalog';

export type EquipSlot = 'cap' | 'top' | 'bottom' | 'shoes' | 'gloves' | 'weapon' | 'cape';
export type RarityId = 'common' | 'uncommon' | 'rare';

export interface RarityDef {
  id: RarityId;
  name: string;
  weight: number;
  optMul: number;
  priceMul: number;
}

export const SLOT_ORDER: EquipSlot[] = [...(seed.SLOT_ORDER as EquipSlot[])];

export const SLOT_LABEL: Record<EquipSlot, string> = {
  cap: '모자',
  top: '상의',
  bottom: '하의',
  shoes: '신발',
  gloves: '장갑',
  weapon: '무기',
  cape: '망토',
};

export const RARITY: Record<string, RarityDef> = structuredClone(seed.RARITY) as Record<string, RarityDef>;

export const RARITY_COLOR: Record<RarityId, string> = {
  common: '#6a5334',
  uncommon: '#2f6fb5',
  rare: '#a97c25',
};

export function applyEquipment(raw: unknown): void {
  const data = requireRecord(raw, 'equipment.json');
  if (Array.isArray(data.SLOT_ORDER)) {
    SLOT_ORDER.length = 0;
    SLOT_ORDER.push(...(data.SLOT_ORDER as EquipSlot[]));
  }
  replaceRecord(RARITY, structuredClone(requireRecord(data.RARITY, 'RARITY')) as Record<string, RarityDef>);
}

if (import.meta.hot) {
  import.meta.hot.accept('./equipment.json', (mod) => {
    if (!mod?.default) return;
    applyEquipment(mod.default);
    emitDataReloadSoon();
  });
}
